<template>
    <v-dialog scrollable
              :value="value"
              @input="toggleModal">
        <v-card class="kbLight">
            <v-toolbar color="kbBlue" dark flat>
                <div v-show="!loadingForm" class="text-h6">{{selectedForm.name}}</div>
                <v-spacer></v-spacer>
                <v-btn icon text @click="toggleModal">
                    <v-icon small>
                        clear
                    </v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-container fluid>
                    <v-row v-if="loadingForm">
                        <v-col class="text-center" cols="12" >
                            <v-progress-circular indeterminate color="kbBlue"></v-progress-circular>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" class="mx-2">
                            <v-row>
                                <h3 class="hidden-xs-only kbDarkBlueText--text"
                                    style="display: inline;"
                                    id="title">{{$t('general.responses')}}</h3>
                                <v-spacer></v-spacer>
                                <v-btn class="mr-4" color="kbBlue" dark @click="exportForm()" :loading="exporting">
                                    <v-icon small left>fas fa-file-excel</v-icon>
                                    {{$t('general.export')}}
                                </v-btn>
                            </v-row>
                        </v-col>

                        <v-col cols="12">
                          <v-data-table :headers="headers"
                                        class="elevation-2"
                                        :items="formSubmits"
                                        item-key="_id"
                                        :options.sync="options"
                                        :expanded.sync="expandedRow"
                                        :footer-props="{
                                                          'items-per-page-text': $t('general.responsesPerPage'),
                                                          'items-per-page-options': [50, 100, 200]
                                                      }"
                                        :server-items-length="totalFormSubmits">
                            <!--<template v-slot:header="{ props }">
                              <th :align="header.align"
                                  v-for="(header, index) in props.headers"
                                  style="min-width: 120px; max-width: 120px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                                  :key="index">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <span v-on="on">{{header.text}}</span>
                                  </template>

                                  <span>
                                    {{header.text}}
                                  </span>
                                </v-tooltip>
                              </th>
                            </template>-->
                            <template v-slot:item="{ item }">
                              <tr @click="expandedRow = [item]">
                                <td style="cursor: pointer">
                                  {{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mma')}}
                                </td>

                                <td v-for="(td, index) in item.fields" :key="index"
                                    style="max-width: 120px; max-height: 60px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor: pointer">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">{{ td.value | formatValue }}</span>
                                    </template>

                                    <span>{{ td.value | formatValue }}</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </template>

                            <template v-slot:no-data>
                              <v-row>
                                <v-col class="text-center" cols="12" v-if="loadingFormSubmits">
                                  {{$t('general.loadingResponses')}}
                                </v-col>
                                <v-col cols="12" class="red--text text-center" v-else>
                                  {{$t('general.noResponsesYet')}}
                                </v-col>
                              </v-row>
                            </template>

                            <template v-slot:expanded-item="{ headers, item }">
                              <td :colspan="headers.length">
                                <v-card :color="$vuetify.theme.isDark ? 'kbDarkGray' : ''" flat>
                                  <v-card-text>
                                    <SubmitDetail :fields="item.fields"
                                                  :files="item.files"
                                                  :submitId="item._id"></SubmitDetail>
                                  </v-card-text>
                                </v-card>
                              </td>
                            </template>
                          </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn @click="toggleModal" color="kbBlue" dark>
                    {{$t('general.close')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import SubmitDetail from '@/pages/App/Forms/dialogs/SubmitDetail.vue'
import TimeZones from '@/mixins/TimeZones'
import { mapState } from 'vuex'
export default {
  components: { SubmitDetail },
  computed: {
    ...mapState({
      formSubmits: state => state.forms.formSubmits,
      loadingForm: state => state.forms.loadingForm,
      selectedForm: state => state.forms.selectedForm,
      loadingFormSubmits: state => state.forms.loadingFormSubmits,
      totalFormSubmits: state => state.forms.totalFormSubmits,
      exporting: state => state.forms.exporting
    }),
    headers () {
      const headersArray = []
      if (!this.selectedForm || !this.selectedForm.fields) return headersArray

      headersArray.push({ text: this.$t('general.date'), align: 'left', sortable: false })
      this.selectedForm.fields.forEach(field => {
        headersArray.push({ text: field.name, align: 'left', sortable: false })
      })
      return headersArray
    }
  },
  data () {
    return {
      expandedRow: [],
      options: {},
      search: ''
    }
  },
  filters: {
    formatValue: (value) => {
      if (Array.isArray(value)) return value.join(', ')
      return value || '-'
    }
  },
  methods: {
    getFormSubmits () {
      this.$store.commit('SET_PAGINATION_FORM_SUBMITS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getFormSubmits')
    },
    exportForm () {
      this.$store.dispatch('exportFormSubmits')
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  mixins: [TimeZones],
  props: ['value'],
  watch: {
    options: {
      handler () {
        this.getFormSubmits()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    selectedForm () {
      this.$store.dispatch('getFormSubmits')
    }
  }
}
</script>
